import styled, { css } from 'styled-components';

export default styled.div`
  position: relative;
  .coupon-modal-body {
    margin: -16px;
    margin-bottom: 0;
  }
`;
